module.exports = __webpack_public_path__ + "img/mp-advantage-5.9234dab7.png";